<template>
  <div>
    <div class="upload_area">
      <div class="upload_block">
        <input type="file" ref="uploadInput" @change="selectFile" accept="accept" style="display: none;"/>
        <output @click="triggerUpload">選擇檔案</output>
        <span>檔案格式(png/jpg/pdf)</span>
      </div>
      <select v-if="yearSelect" v-model="year" class="select" placeholder="選擇學年期">
        <option v-for="yearOption in yearOptions">{{ yearOption }}</option>
      </select>
      <div v-for="(uploadFile, index) in uploadFileList" class="file_block">
        <span>{{ limitFileName(uploadFile.name) }}</span>
        <span class="delete" @click="deleteSelectedFile(index)"></span>
        <span class="space"></span>
        <span class="new">new</span>
        <span class="file_size">{{ sizeToString(uploadFile.size) }}</span>
      </div>
      <button class="btn--pill pill" :class="uploadFileList.length ? 'blue' : 'darken_gray'" @click="upload" :disabled="!uploadFileList.length">上傳</button>
    </div>
    <div class="table_holder">
      <table>
        <thead>
          <tr> <th>名稱</th> <th>下載</th> <!--th>列印</th--> <th>刪除</th> </tr>
        </thead>
        <tbody>
          <tr v-if="checkDownloadFile">
            <td> 尚未有檔案上傳 </td>
            <td></td>
            <!-- <td> <button class="d-inline-block btn--pill pill blue">列印</button> </td> -->
            <td></td>
          </tr>
          <tr v-for="downloadFile in downloadFileList">
            <td>{{ fileName(downloadFile.url) }}</td>
            <td> <button class="d-inline-block btn--pill pill blue" @click="download(downloadFile.id)">下載</button> </td>
            <!-- <td> <button class="d-inline-block btn--pill pill blue">列印</button> </td> -->
            <td> <button class="icon_btn delete_btn" @click="deleteFile(downloadFile.id)"></button> </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { getYearOptions } from '~components/common/forms/UniversalOptions.js'
export default {
  name: 'InternFileUpload',
  components: {
  },
  props: {
    yearSelect: {
      type: Boolean,
      default: false
    },
    downloadFileList: {
      type: Array,
      default: () => []
    },
    oneFileAtTime: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    yearOptions () {
      return getYearOptions();
    },
    accept () {
      return this.selectableType.join(',');
    },
    checkDownloadFile(){
      return (this.downloadFileList.length) ? 0 : 1;
    },
  },
  data () {
    return {
      uploadFileList: [],
      year: null,
      selectableType: ['image/png', 'image/jpeg', 'application/pdf'],
    }
  },
  methods: {
    triggerUpload () {
      if(!this.$refs.uploadInput) return;
      if(this.oneFileAtTime) {
        this.uploadFileList = [];
      }
      else if(this.uploadFileList.length >= 3) {
        alert('最多選擇三個檔案。');
        return;
      }
      this.$refs.uploadInput.click();
    },
    selectFile () {
      const file = this.$refs.uploadInput.files[0];
      let max = 1024 * 1024 * 2; //2MB
      let size = file.size;
      if(this.selectableType.indexOf(file.type) == -1) {
        alert('檔案格式錯誤，限png/jpg/pdf。');
      }
      else if(size > max) {
        alert('檔案大小超過' + this.sizeToString(max) + '。');
      }
      else {
        this.uploadFileList.push(file);
      }
      this.$refs.uploadInput.value = null;
    },
    deleteSelectedFile (index) {
      this.uploadFileList.splice(index, 1);
    },
    async upload () {
      if(!this.uploadFileList.length) {
        alert('未選擇檔案。');
        return;
      }
      if(this.oneFileAtTime) {
        this.$emit('upload', this.uploadFileList[0], this.year);
      }
      else {
        this.$emit('upload', [...this.uploadFileList], this.year);
      }
      this.uploadFileList = [];
    },
    async download (form_id) {
      this.$emit('download', form_id);
    },
    async deleteFile (form_id) {
      this.$emit('deleteFile', form_id);
    },
    limitFileName(name){
      var ext = name.substring(name.lastIndexOf(".") + 1, name.length).toLowerCase();
      var filename = name.replace('.' + ext,'');
      if(name.length <= 11) {
        return name;
      }
      filename = filename.substr(0, 7) + '...';
      return filename + '.' + ext;
    },
    fileName (url) {
      if(typeof url != 'string') return '-';
      return url.replace(/.*\//g, '').replace(/^[^_]*_[^_]*_/,'');
    },
    sizeToString (size) {
      let quantifiers = ['Bytes', 'KB', 'MB', 'GB'];
      let i = 0;
      while(size > 900 && i + 1 <= quantifiers.length) { i++; size /= 1024; }
      size = +(Math.round(size + "e+1") + "e-1");
      return size + quantifiers[i];
    },
  }
}
</script>
<style lang="scss" scoped>
  .upload_area {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    @media (max-width: 768px) {
      align-items: center;
      .upload_block, output, select, .file_block { width: 100%; }
    }
  }
</style>
